export default "__VITE_ASSET__03894eff__"